import * as angular from 'angular';

import { Trend } from '../../models/Trend';
import { ILoggerService, IRequestService } from '../../services';

export interface ITrendService {
    getAll(): angular.IPromise<Trend[]>;
    getTrend(guid: string): angular.IPromise<Trend>;
    addTrend(trend: Trend): angular.IPromise<any>;
    updateTrend(trend: Trend): angular.IPromise<any>;
    deleteTrend(guid: string): angular.IPromise<any>;
}

export class TrendService implements ITrendService {

    static serviceId = 'trendService';

    private _controllerName = 'trend/';
    private _controllerUrl: string;

    static $inject = ['requestService', 'loggerService'];

    constructor(
        private _requestService: IRequestService,
        private _loggerService: ILoggerService
    ) {
    }

    private controllerUrl() {
        if (!this._controllerUrl) {
            this._controllerUrl = this._requestService.getUrlV1() + this._controllerName;
        }
        return this._controllerUrl;
    }

    getTrend(guid: string): angular.IPromise<Trend> {
        const url = this.controllerUrl() + guid;
        return this._requestService.get(url, undefined, true)
            .then(data => {
                const result = angular.copy(data);
                try {
                    result.configuration = JSON.parse(data.configuration);
                } catch (reason) {
                    this._loggerService.logError(reason);
                }
                return result;
            });
    }

    getAll(): angular.IPromise<Trend[]> {
        const url = this.controllerUrl();
        return this._requestService.get(url, undefined, true)
            .then((data) => {
                const copy = angular.copy(data);
                try {
                    copy.forEach(d => {
                        d.configuration = JSON.parse(d.configuration);
                    });
                } catch (reason) {
                    this._loggerService.logError(reason);
                }
                return copy;
            });
    }

    addTrend(trend: Trend): angular.IPromise<any> {
        const url = this.controllerUrl();
        const data = angular.copy(trend);
        (<any>data).configuration = JSON.stringify(trend.configuration);
        this._requestService.cleanCache(url);
        return this._requestService.post(url, data, undefined, true);
    }

    updateTrend(trend: Trend): angular.IPromise<any> {
        const url = this.controllerUrl() + 'update';
        const data = angular.copy(trend);
        (<any>data).configuration = JSON.stringify(trend.configuration);
        this._requestService.cleanCache(this.controllerUrl());
        return this._requestService.post(url, data, undefined, true);
    }

    deleteTrend(guid: string): angular.IPromise<any> {
        const url = this.controllerUrl() + guid;
        this._requestService.cleanCache(this.controllerUrl());
        return this._requestService.delete(url);
    }
}